
import type { ArticleContent } from '@/lib/articleContent';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { ArticleHtmlChunk, renderArticleBlock } from '@/components/help-center/ArticleBodyRender';
import { cn } from '@/lib/utils';

type GuidePreviewDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  categoryLabel?: string;
  body: ArticleContent;
};

export function GuidePreviewDialog({
  open,
  onOpenChange,
  title,
  categoryLabel,
  body,
}: GuidePreviewDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className={cn(
          'flex max-h-[92vh] w-[min(100vw-1rem,1200px)] max-w-[calc(100vw-1rem)] translate-x-[-50%] translate-y-[-50%] flex-col gap-0 overflow-hidden border border-gray-200 bg-gray-50 p-0 sm:rounded-2xl lg:max-w-[min(1200px,calc(100vw-2rem))]'
        )}
      >
        <DialogHeader className="shrink-0 border-b border-gray-200 bg-white px-6 py-4 text-left">
          <DialogTitle className="font-poppins text-xl text-gray-900">Pré-visualização</DialogTitle>
          <DialogDescription className="text-left text-gray-600">
            {categoryLabel ? <span className="font-medium text-gray-800">{categoryLabel}</span> : null}
            {categoryLabel ? ' · ' : null}
            Vista aproximada do artigo no help center — alterações ainda não gravadas.
          </DialogDescription>
        </DialogHeader>
        <div className="min-h-0 flex-1 overflow-y-auto p-4 md:p-6">
          <article className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm md:p-10">
            <h1 className="mb-6 font-poppins text-3xl font-bold leading-tight text-gray-900">
              {title.trim() || 'Sem título'}
            </h1>
            <div className="prose prose-lg max-w-none">
              <div className="mb-8 border-b border-gray-100 pb-8 text-left text-xl leading-relaxed text-gray-700">
                <ArticleHtmlChunk html={body.intro} className="text-xl leading-relaxed" />
              </div>
              {body.blocks.map((block, idx) => renderArticleBlock(block, idx))}
            </div>
          </article>
        </div>
      </DialogContent>
    </Dialog>
  );
}
